import { render, staticRenderFns } from "./ObrociTable.vue?vue&type=template&id=255c36a6"
import script from "./ObrociTable.vue?vue&type=script&lang=js"
export * from "./ObrociTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports